import { UserAccessPoint } from "../interfaces/UserAccessPoint";

export interface Option { value: string; label: string; }

/**
 * Returns available generic status options.
 */
export const STATUS_OPTIONS: Option[] = [
  { value: "0", label: 'Tidak Aktif' },
  { value: "1", label: 'Aktif' },
]

/**
 * Returns status label based on number provided
 * @param status number
 * @returns string or null
 */
export const getStatusLabel = (status: number): string | null => {
  if (status === 0) return "Tidak Aktif";
  else if (status === 1) return "Aktif";
  else return null;
}

/**
 * Returns color code in hexadecimal based on status
 * provided.
 * @param status number
 * @returns color code in hex
 */
export const getStatusColor = (status: number): string | null => {
  if (status === 0) return "#d42822"; // for status tidak aktif
  else if (status === 1) return "#7eb81c"; // for status aktif
  else return null;
}

/**
 * Generate value for react <Select> based on options
 * provided. This function made specifically for generic
 * status option.
 */
export const getSelectedStatusOption = (status: number | null | undefined): Option | null => {
  if (typeof status === 'undefined' || status === null) {
    return null;
  }
  const statusLabel = getStatusLabel(status);
  if (!statusLabel) return null;
  const returnData: Option = {
    value: status.toString(),
    label: statusLabel
  }
  return returnData;
}

/**
 * Check if user is allowed to save or not
 * @param path 
 * @param role 
 * @returns 
 */
export const allowSave = (role: UserAccessPoint, idLoc?: number) => {
  const paths = window.location.pathname.split("/");
  if (paths[idLoc || 2] === 'create') {
    if (role.create) return true;
    return false;
  } else {
    if (role.update) return true;
    return false;
  } 
}

/**
 * Check if user is allowed to delete or not
 * @param path 
 * @param role 
 * @returns 
 */
 export const allowDelete = (role: UserAccessPoint, idLoc?: number) => {
  const paths = window.location.pathname.split("/");
  if (paths[idLoc || 2] === 'create') {
    if (role.create) return true;
    return false;
  } else {
    if (role.delete && role.update) return true;
    return false;
  } 
}